import { render, staticRenderFns } from "./Reg_selectSex.vue?vue&type=template&id=1a99d2dc&scoped=true"
import script from "./Reg_selectSex.vue?vue&type=script&lang=js"
export * from "./Reg_selectSex.vue?vue&type=script&lang=js"
import style0 from "./Reg_selectSex.vue?vue&type=style&index=0&id=1a99d2dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a99d2dc",
  null
  
)

export default component.exports